import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";
import ModuleQuestion from "../../components/ModuleQuestion";

const Module_1_0 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">3.0.20 Case 20</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="A"
          assessmentName="self_assessment_120"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is self-assessment case number one, two, zero, or 120. This
                is a positive case. Beginning at the level of the cerebellum and
                moving superiorly, we enter into the occipital regions, seen
                here. Intense uptake is seen extending to the cortical rim,
                within the left occipital lobe, identified here. This intense
                activity is within the gray matter and is surrounded by less
                intense uptake within the white matter. Focal uptake within the
                gray matter, exceeding that of the adjacent white matter, makes
                this case positive. There is complete loss of gray-white
                contrast in the left and right occipital regions. In addition,
                focal uptake can also be seen within the right occipital region
                as well. As we enter into the temporal lobes bilaterally,
                distinct white matter tracts are not visualized on the left- or
                on the right-hand side. Although there is evidence of
                enlargement of the ventricles, which may be forcing the cortex
                toward the periphery, again, white matter tracts are not
                visualized. This pattern of continued loss of gray-white
                contrast is seen throughout the temporal and occipital regions.
                As we enter into the frontal cortices, seen here, white matter
                tracts may be visualized in the left frontal cortex, here.
                However, on the right-hand side, increased activity is seen
                within the gray matter, and there is loss of gray-white contrast
                without good visualization of white matter tracts. Continuing to
                move upwards, this pattern continues on the right-hand side. On
                the left-hand side, there is now loss of gray-white contrast.
                Therefore, both frontal cortices are positive for loss of
                gray-white contrast. As we enter into the parietal region, white
                matter tracts are not identifiable, coursing from the front to
                the back of the brain, on the left or on the right. There is
                loss of gray-white contrast throughout. In the upper parietal
                region, this pattern continues. Distinct white matter tracts are
                not visualized on either side. Furthermore, in the medial
                parietal region, which can be identified here, increased
                activity is seen in the midline. On the sagittal images, the
                medial parietal region, which includes the precuneus, shows
                increased activity over here. Continuing to the top of the
                brain, loss of gray-white contrast can be seen throughout the
                parietal region. Therefore, as there is loss of gray-white
                contrast in the parietal, frontal, occipital, and temporal
                regions, this case is positive. If you called this case
                negative, please review the case once again in the MIM Viewer,
                concentrating on the regions described. While there is clear
                loss of gray-white contrast in the temporal and occipital
                regions, the more subtle areas, seen in the left frontal cortex
                and also in the parietal region, should also be reviewed.
              </p>
            </>
          }
          previousLesson="/module-3/module-3-0-19"
          nextLesson="/module-3/module-3-0-21"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_535466820&entry_id=1_s77g7xio&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          questionType="assessment"
          videoId="1_s77g7xio"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
